define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const _ = require('underscore');
    const device = require('util/device.util');
    const BaseView = require('common/base.view');
    const domUtil = require('util/dom.util');
    const Form = require('class/form.class');
    const i18n = require('i18n');
    const validation = require('util/validation.util');
    const CustomNationality = require('../../common/swiss-theme/customElements/customNationality/customNationality');
    const CustomEmail = require('../../common/swiss-theme/customElements/customEmail/customEmail');

    Form.prototype.customControlsMap = _.extend({}, Form.prototype.customControlsMap, {
        'customNationality': CustomNationality,
        'customEmail': CustomEmail
    });

    Form.prototype._getAllData = function(mutators) {
        var formData = {};

        this.serializeToArray(this.el, false).forEach(function(field) {
            const isCustomValue = document?.querySelector(`[name=${field.name}]`)?.dataset.hasOwnProperty('value') && document.querySelector(`[name=${field.name}]`)?.dataset.value;
            if (isCustomValue) {
                formData[field.name] = isCustomValue;
            } else {
                formData[field.name] = field.value;
            }
        });

        return this._mutate(formData, mutators);
    };

    Form.prototype.delegateEvents = function() {
        let lastActiveInput = null;
        const tapEvent = 'tap.form' + this.options.id;
        const focusInEvent = 'focusin.form' + this.options.id;
        const eventName = device.formFactor === 'desktop' ? 'mousedown.form' : 'touchstart.form';
        let validationEvent;

        const isEventTriggeredOnFormField = function(e) {
            return Array.from(this.$elements).some(function(el) {
                let isInField = el.contains(e.target);

                if (isInField) {
                    var error = el.querySelector('.error-tooltip');
                    isInField = !error || !error.contains(e.target);
                }

                return isInField;
            });
        }.bind(this);

        const getFormControlFromEvent = function(e) {
            return Array.from(this.$elements).filter(function(el) {
                return el.contains(e.target);
            })[0];
        }.bind(this);

        const findPositionDropdown = function(e) {
            const selectContainer = e.target.offsetParent;
            const menuEl = selectContainer.querySelector('.hidden-menu');

            if (menuEl) {
                const selectHeight = selectContainer.offsetHeight;
                const dropdown = e.target.closest('.dropdown');
                const isErrorTooltip = dropdown.querySelector('.error-tooltip');
                const errorHeight = isErrorTooltip ? isErrorTooltip.offsetHeight : 0;
                const dropdownField = dropdown.offsetHeight;
                const targetDimension = e.currentTarget.getBoundingClientRect();
                const moveTop = dropdownField + selectHeight - e.target.offsetHeight - errorHeight;
                const positionElement = targetDimension.top + targetDimension.height / 2;
                const deviceHeight = window.document.documentElement.clientHeight;
                const middleOfHeight = deviceHeight / 2;

                if (middleOfHeight < positionElement && menuEl) {
                    menuEl.style.top = `-${moveTop}px`;
                } else {
                    menuEl.style.top = `auto`;
                }
            }
        };

        this._setAutoFocus();

        if (!domUtil.isPlaceholderSupported) {
           // domUtil.setCustomPlaceholder(this.$el.find('input'));
        }

        // fix dropDown list after device rotation on SGT3
        $(window).on('resize.form', _.throttle(function() {
            const isSelect = document.activeElement.tagName.toLowerCase() === 'select';
            const isSGT3 = device.alias === 'galaxy_tab_3_10';
            const isChrome = device.browserName === 'chrome';

            if (!document.activeElement || !document.activeElement.tagName) {
                return;
            }

            if (isSelect && isSGT3 && isChrome) {
                document.activeElement.blur();
            }
        }, 500));

        // fix for iOS 10
        if (device.os === 'ios' && parseInt(device.osVersion) === 10) {
            this.$el.on('submit.form', BaseView.hideKeyboard);
        }

        this.$elements.find('select, input[type="checkbox"], input[type="radio"].segmented-radio')
            .on('change.form', function(e) {
                BaseView.redraw(e.target);
            });

        $('body')
            .on(tapEvent + ' ' + focusInEvent, function(event) {
                let isSameField = false;
                const isFormFieldEvent = isEventTriggeredOnFormField(event);
                const $activeFormField = isFormFieldEvent ? $(getFormControlFromEvent(event)) : null;
                const isEnabledFiled = !event.target.disabled;

                if (event.target.tagName === 'INPUT' && event.type === 'focusin') {
                    if (!event.target.classList.contains('fn-select')) {
                        if (event.target.nextElementSibling) {
                            event.target.nextElementSibling.classList.add('label-above');
                            event.target.offsetParent.classList.add('active-input-field');
                        }
                    }
                }

                if (event.target?.classList?.contains('invalid') && !event.target?.classList?.contains('fn-dropdown') && event.type === 'click') {
                    const input = event.target.querySelector('input');
                    if (input) {
                        const active = event.target.querySelector('.field__control');
                        input.focus();
                        active && active.classList.add('active-input-field');
                    }
                }

                if (isFormFieldEvent && event.type === 'focusin') {
                    $activeFormField.trigger('form:focusin.form');
                }

                if ($activeFormField && isEnabledFiled && !$activeFormField[0]?.className?.includes('fn-loss-limit-generic') && !$activeFormField[0]?.className?.includes('field_name_self-exclusion')) {
                    this.resetField($activeFormField);
                }

                if ($activeFormField && isEnabledFiled && !$activeFormField[0]?.className?.includes('fn-loss-limit-generic')) {
                    if (!$activeFormField[0]?.querySelector('input').value) {
                        this.resetField($activeFormField);
                    }
                }

                if (validationEvent) {
                    isSameField = $activeFormField && $activeFormField[0].contains(validationEvent.target);

                    // Avoid validation if dropdown selected.
                    if (!(event.relatedTarget?.className === 'fn-lookup-input-text' && event.relatedTarget.autocomplete === 'off') && event.relatedTarget?.className !== 'select-selected fn-select') {
                        if (!isSameField) {
                            if (getFormControlFromEvent(validationEvent)?.classList?.contains('fn-loss-limit-generic')) {
                                this.validateField(getFormControlFromEvent(validationEvent), this.options.data, {
                                    event: validationEvent
                                });
                            } else {
                                if (getFormControlFromEvent(validationEvent).getElementsByTagName('input')[0].value !== '') {
                                    let invalidElementsExceptRadioBox = [];
                                    let isRadioInvalid = false;
                                    let isAnyFieldValid = false;
                                    // If invalid and empty then remove error-tooltip
                                    for (let i = 0; i < this.$elements.length; ++i) {
                                        if (this.$elements[i]?.classList?.contains('invalid') && this.$elements[i]?.querySelector('input')?.value === '') {
                                            this.$elements[i]?.classList.remove('invalid');
                                            this.$elements[i].querySelector('.error-tooltip').remove();
                                        }
                                    }
                                    const input = getFormControlFromEvent(validationEvent)?.getElementsByTagName('input')[0];
                                    const attrValue = input.getAttribute('value');
                                    const inputValue = input.value;
                                    attrValue !== inputValue && this.validateField(getFormControlFromEvent(validationEvent), this.options.data, {
                                        event: validationEvent
                                    });

                                    for (let k = 0; k < this.$elements.length; ++k) {
                                        // Check radio box
                                        if (this.$elements[k]?.classList?.contains('invalid') && this.$elements[k]?.classList?.contains('radio')) {
                                            isRadioInvalid = true;
                                        }

                                        if (this.$elements[k]?.classList?.contains('invalid') && !this.$elements[k]?.classList?.contains('radio')) {
                                            invalidElementsExceptRadioBox.push(this.$elements[k]);
                                        }

                                        if (this.$elements[k]?.classList?.contains('valid')) {
                                            isAnyFieldValid = true;
                                        }
                                    }

                                    for (let f = 0; f < this.$elements.length; ++f) {
                                        if (this.$elements[f]?.classList?.contains('radio') && isRadioInvalid && invalidElementsExceptRadioBox.length > 0) {
                                            this.$elements[f]?.querySelector('.error-tooltip')?.remove();
                                        }

                                        if (isAnyFieldValid && this.$elements[f]?.classList?.contains('radio') && this.$elements[f]?.classList?.contains('invalid')) {
                                            this.$elements[f]?.querySelector('.error-tooltip')?.remove();
                                        }
                                    }
                                }
                            }
                        }
                    }
                    validationEvent = null;
                }
            }.bind(this))
            .on('focusout.form' + this.options.id, function(event) {
                if (isEventTriggeredOnFormField(event)) {
                    $(event.target).trigger('form:focusout.form');
                    validationEvent = event;
                }

                if (event.target.tagName === 'INPUT' && event.type === 'focusout') {
                    if (!event.target?.classList?.contains('fn-select')) {
                        if (!event.target?.value && event.target?.nextElementSibling && event.target?.className !== 'fn-nationality-input-text') {
                            event.target?.nextElementSibling?.classList.remove('label-above');
                        }
                        event.target?.offsetParent?.classList?.remove('active-input-field');
                    }
                }
            })
            .on('keydown.form' + this.options.id, function(event) {
                var { key, target } = event;
                var spaceKey = key === 'Enter';

                if (event.key === 'Enter' && $('.form.form_name_registration').length === 0) {
                    const isTooltip = lastActiveInput?.parentNode?.parentNode?.querySelector('.error-tooltip');
                    lastActiveInput = document.activeElement;

                    if (!isTooltip && !lastActiveInput?.parentNode?.parentNode?.classList?.contains('invalid') && lastActiveInput?.parentNode?.parentNode?.querySelector('input').value !== '') {
                        this.validateField(lastActiveInput?.parentNode?.parentNode, this.options.data, {
                            event: event
                        });
                    }
                }

                if (spaceKey && target.className.includes(this.hightlightControlClass)) {
                    event.preventDefault();
                    event.stopImmediatePropagation();

                    var inputElement = target.querySelector('input') || {};
                    var { type, checked } = inputElement || {};

                    if (type !== 'radio' && type !== 'checkbox' || checked && type === 'radio') {
                        return;
                    }

                    inputElement.checked = !checked;
                    $(inputElement).trigger('change');
                }
            }.bind(this));

        this.$el.on(eventName, '.fn-toggle-password-visibility', this.handleTogglePasswordVisibility.bind(this));

        this.$el[0].querySelectorAll('.fn-select').forEach(item => {
            item.addEventListener('click', (event) => {
                const customSelect = event.target.closest('.custom-select');
                const isFormFieldEvent = isEventTriggeredOnFormField(event);
                const $activeFormField = isFormFieldEvent ?
                    $(getFormControlFromEvent(event)) :
                    null;
                const nationalityDropDown = $activeFormField && $activeFormField[0]?.className?.includes('default-custom-select');

                const isRegisterPortlet = this.el.classList.contains('form_name_registration');
                const isMobile = device.formFactor === 'mobile';
                const isRegisterMobile = isRegisterPortlet && isMobile && nationalityDropDown;
                const isNotProduct = $activeFormField && !$activeFormField.hasClass('field_name_self-exclusion-product');
                const isNotPeriod = $activeFormField && !$activeFormField.hasClass('field_name_self-exclusion-period');
                const isNotSelfExclusion = isNotProduct && isNotPeriod;

                if (customSelect?.classList?.contains('expanded')) {
                    customSelect?.classList?.remove('expanded');
                    $activeFormField && $activeFormField[0].className.includes('field_name_self-exclusion') && $activeFormField[0].classList.add('valid');

                    if ($activeFormField && $activeFormField.hasClass('fn-validate-focusout') && isNotSelfExclusion) {
                        event.stopPropagation();
                        this.validateField($activeFormField, this.options.data, {
                            event: event
                        });
                        isRegisterPortlet && isRegisterPortlet && $(event.target).trigger('form:focusout.register');
                    }

                } else if (!customSelect?.classList?.contains('expanded')) {
                    customSelect?.classList.add('expanded');
                    isRegisterMobile && findPositionDropdown(event);

                    $activeFormField && this.resetField($activeFormField);
                }

            });
        });

        document.querySelector('body').addEventListener('click', (event)=> {
            const customSelect = $('.custom-select');
            const activeCustomSelect = event.target.offsetParent?.offsetParent;

            if (!activeCustomSelect?.classList?.contains('custom-select')) {
                customSelect.forEach(el => {
                    if (el.offsetParent?.className?.includes('field_name_self-exclusion') && el.offsetParent.querySelector('input').value) {
                        el.offsetParent?.classList.add('valid');
                    }
                    el.classList.remove('expanded');
                });
            } else {
                customSelect.forEach(el => activeCustomSelect !== el && el.classList.remove('expanded'));
            }
        });

        this.$el[0].querySelectorAll(`.select-item`).forEach(item => {
            item.addEventListener('click', event => {
                const isRegisterPortlet = this.el?.classList?.contains('form_name_registration');
                const message = event.target.innerText;
                const customSelect = event.target.closest('.custom-select');
                const isFormFieldEvent = isEventTriggeredOnFormField(event);
                const $activeFormField = isFormFieldEvent && event ?
                    $(getFormControlFromEvent(event)) :
                    null;

                if (event.currentTarget?.classList?.contains('fn-select-dropdown')) {
                    const selectedValue = event.target.getAttribute('value');
                    const field = event.target.closest('.field');
                    field.querySelector('.fn-input-hidden').value = selectedValue;

                    if (selectedValue === this.options.data.UNLIMITED_AMOUNT) {
                        field.querySelector('.fn-input-text').setAttribute('value', event.target.innerHTML);
                    } else {
                        const valueWIthCurrency = event.target.dataset.currencySymbol + ' ' + event.target.innerHTML;
                        field.querySelector('.fn-input-text').setAttribute('value', valueWIthCurrency);
                    }
                }

                if (customSelect) {
                    const selectValue = customSelect.querySelector('.select-selected');
                    const selectedItem = customSelect.querySelector('.selected');

                    customSelect?.classList?.remove('expanded');
                    customSelect?.classList?.add('chosen');

                    if (!customSelect?.classList?.contains('fn-editable-control')) {
                        customSelect.querySelector('.select-selected-wrapper').innerHTML = message;
                        selectValue.setAttribute('value', event.target.getAttribute('value'));
                    }

                    selectedItem && selectedItem.classList.remove('selected');
                    event.target.classList.add('selected');
                }

                if ($activeFormField && validationEvent && $activeFormField.hasClass('fn-validate-focusout')) {
                    event.stopPropagation();
                    this.validateField(getFormControlFromEvent(validationEvent), this.options.data, {
                        event: event
                    });
                    isRegisterPortlet && isRegisterPortlet && $(event.target).trigger('form:focusout.register');
                }
            });
        });

        return this;
    };

    Form.prototype.setElement = function($el) {
        this.el = $el[0];
        this.$el = $el;

        this.renderCustomControls();
        this.delegateEvents();
        this.detectControlsType();
        this.wrapFormControls();

        const dropdownNoSelectedList = this.el.querySelectorAll('.dropdown-no-selected-value');
        const dropdownWithSelectedList = this.el.querySelectorAll('.dropdown-with-selected-value');

        dropdownNoSelectedList.length && dropdownNoSelectedList.forEach(dropdown => {
            const selectWrapper = dropdown.querySelector('.select-selected-wrapper');
            const firstListValue = dropdown.querySelector('.select-item');
            const selectValue = dropdown.querySelector('.select-selected');

            if (!selectWrapper.innerHTML) {
                selectWrapper.innerHTML = firstListValue.innerHTML;
                selectValue.setAttribute('value', firstListValue.getAttribute('value'));
            }
        });

        dropdownWithSelectedList.length && dropdownWithSelectedList.forEach(dropdown => {
            const selectWrapper = dropdown.querySelector('.select-selected-wrapper');
            const selectedItem = dropdown.querySelectorAll('.select-item[selected]');
            const selectValue = dropdown.querySelector('.select-selected');

            if (!selectWrapper.innerHTML) {
                selectWrapper.innerHTML = selectedItem[0].innerHTML;
                selectValue.setAttribute('value', selectedItem[0].getAttribute('value'));
            }
        });

        this.selectedData = this.data();

        return this;
    };

    Form.prototype.showErrorTooltip = function($field, data) {
        const $errorTooltip = $field.find('.error-tooltip');
        const message = i18n.t(data?.dynamicMessage || data?.message || '');
        const isChangePass = this.el?.className?.includes('form_name_user-change-password') && $field[0]?.classList?.contains('field_name_new-password');
        const isForgotPass = this.el?.className?.includes('form_name_forgot-password-set-new') && $field[0]?.classList?.contains('field_name_password');
        const isRegistrationPassword = this.el?.className?.includes('form_name_registration') && $field[0]?.classList?.contains('password');
        const passwordValue = isRegistrationPassword && $field[0].querySelector('input').value;

        if ($errorTooltip.length === 0) {
            if (isChangePass || isForgotPass) {
                $field.append('<div class="error-tooltip"></div>');
            } else if (isRegistrationPassword && passwordValue.length > 0) {
                $field.append('<div class="error-tooltip"></div>');
                $('.error-tooltip').addClass('no-before-tooltip');
                $('.error-tooltip').addClass('no-before-tooltip-transparent');
            } else {
                $field.append('<div class="error-tooltip">' + message + '</div>');
            }
        } else {
            $errorTooltip.html(message);
        }

        return this;
    };

    Form.prototype.validateField = function(field, data, options) {
        options = options || {};

        var dfd = $.Deferred();

        dfd = validation.validateDomField($(field), {
            validationConfig: this.options.validationConfig,
            form: this,
            dfd: dfd,
            event: options.event,
            nextField: options.nextField,
            data: data
        });

        dfd.fail(function(validationData) {
            let validationDataType;
            const isPasswordField = !field?.length && !field?.length > 0 && field?.getElementsByTagName('input')[0]?.classList?.contains('fn-input-type-password');
            const isRegisterPopup = $('.register-popup').length !== 0;
            const passwordHints = $('.form__fieldset.fieldset_name_passwordRule.passwordRule.fn-password-rule')[0];
            const isContainsHidden = passwordHints && passwordHints.classList.contains('hidden');
            const invalidDataMessage = {
                id: 99,
                message: i18n.t('playtech.mobile.system.user.tooltip.password.required'),
                priority: 0,
                type: 'required'
            };

            if (isRegisterPopup && isPasswordField && !field.getElementsByTagName('input')[0].value) {
                validationDataType = invalidDataMessage;
                if (isContainsHidden) {
                    this.setFieldInvalid($(field), validationDataType);
                }
            } else if (isRegisterPopup && isPasswordField && field.getElementsByTagName('input')[0].value) {
                validationDataType = invalidDataMessage;
                validationDataType.message = '';
                passwordHints?.classList?.contains('hidden') && this.setFieldInvalid($(field), validationDataType);
                this.isStopValidate = true; // If set field invalid stopValidation = true
            } else {
                const isLoginPassForm = this.el?.className?.includes('form_name_login') && field?.classList?.contains('field_name_password');

                if (isLoginPassForm) {
                    if (!window.document.getElementsByClassName('fn-login-btn continueLoginBtn')[0]?.classList?.contains('hidden')) {
                        return this;
                    }
                }

                validationDataType = validationData;
                this.setFieldInvalid($(field), validationDataType);
                this.isStopValidate = true; // If set field invalid stopValidation = true
            }
        }.bind(this)).done(function(validationData) {
            this.setFieldValid($(field), validationData);
        }.bind(this));

        return dfd.promise();
    };

    Form.prototype.validate = function(selector, data, options, isSilent) {
        this.isStopValidate = false; // Reset stopValidation to false
        let validations;
        let newElementsLogin = [];
        const loginFormSelector = $('.login-form');
        const registerFormPopupSelector = $('.register-popup');
        const isLoginForm = loginFormSelector && loginFormSelector.length > 0;
        const isRegisterPopup = registerFormPopupSelector && registerFormPopupSelector.length > 0;
        let process = $.Deferred();

        if (this.validationInProgressFields.length) {
            return process.reject();
        }

        let elements = selector ? $(selector) : this.$elements;

        if (isLoginForm) {
            for (let i = 0; i < elements.length; i++) {
                if (elements[i].getElementsByTagName('input')[0].value === '') {
                    newElementsLogin.push(elements[i]);
                    break;
                }
            }
        }

        this.hideErrorMessages();

        if (isLoginForm) {
            validations = newElementsLogin.map(function(field) {
                setTimeout(() => {
                    return this.validateField(field, data, options);
                }, 0);

                return this.validateField(field, data, options);
            }, this);
        } else if (isRegisterPopup) {
            validations = this.processValidationsRegistration(elements, data, options);
        } else {
            validations = this.processValidationsAllFields(elements, data, options);
        }

        $.when.apply($, validations)
            .fail(function() {
                this.isValid = false;
                process.reject({
                    ok: false,
                    message: 'Data is invalid'
                });
            }.bind(this))
            .done(function() {
                if (!isSilent) {
                    this.selectedData = this.data();
                }

                process.resolve(this.selectedData, this);
            }.bind(this));

        return process;
    };

    Form.prototype.processValidationsRegistration = function(elements, data, options) {
        let validations = [];
        let validationsLossLimitCheckBox = [];
        let invalidElementsExceptRadioBox = [];
        let isRadioInvalid = false;
        let isLossLimitInValid = false;

        if (elements.hasClass('fn-loss-limit-generic')) {
            validations = elements.map(function(field) {
                if (!field?.classList?.contains('checkbox')) {
                    if (field?.classList?.contains('invalid')) {
                        isLossLimitInValid = true;
                    }
                    return this.validateField(field, data, options);
                }

                return null;
            }, this);

            if (!isLossLimitInValid) { // If all dropdowns valid check checkbox
                for (let x = 0; x < elements.length; ++x) {
                    if (elements[x]?.classList?.contains('checkbox')) {
                        validationsLossLimitCheckBox.push(this.validateField(elements[x], data, options));
                    }
                }
            }

            validationsLossLimitCheckBox.length === 0 && $('.checkbox .error-tooltip').remove();

            return validations.concat(validationsLossLimitCheckBox);
        }

        // Check radio box
        for (let i = 0; i < elements.length; ++i) {
            const isRadioField = elements[i]?.classList?.contains('radio');
            if (elements[i]?.classList?.contains('invalid') && isRadioField) {
                isRadioInvalid = true;
            }

            if (elements[i]?.classList?.contains('invalid') && !isRadioField) {
                invalidElementsExceptRadioBox.push(elements[i]);
            }
        }

        let emptyInputs = [];
        let invalidInputs = [];
        // Checking input fields and write index to array
        for (let t = 0; t < elements.length; ++t) {
            const isAddrLookupHidden = elements[t]?.classList?.contains('address-lookup-hidden');
            if (elements[t]?.getElementsByTagName('input')[0]?.value === '' && !elements[t]?.classList?.contains('field_name_coupon') && !isAddrLookupHidden) {
                emptyInputs.push(t);
            }

            if (elements[t]?.classList?.contains('invalid') && !isAddrLookupHidden) {
                invalidInputs.push(t);
            }
        }

        /* TODO: Registration form validations not very good, need to find out new solution to make it more clear
        *   very time expensive to support this file.
        */
        for (let i = 0; i < elements.length; ++i) {
            // Check if userName
            if (elements[i]?.className?.includes('userName') && elements[i].querySelector('input').value !== '') {
                validations.push(this.validateField(elements[i], data, options));
            }

            const dateValue = elements[i]?.querySelector('input')?.value;
            const str = dateValue?.split('.').join('');

            // Check on each step
            let emptyInputsOnStep = [];
            let invalidInputsOnStep = [];
            // Checking input fields and write index to array
            for (let q = 0; q < elements.length; ++q) {
                if (elements[q]?.getElementsByTagName('input')[0]?.value === '' && !elements[q]?.classList?.contains('field_name_coupon')) {
                    emptyInputsOnStep.push(q);
                }

                if (elements[q]?.classList?.contains('invalid')) {
                    invalidInputsOnStep.push(q);
                }
            }
            // check end

            if (!elements.hasClass('fn-lookup')) { // For second registration step
                if (emptyInputs.includes(invalidInputs[0])) {
                    validations.push(this.validateField(this.$elements[emptyInputs[0]], data, options));

                    if (!$('.passwordRule')[0]?.classList?.contains('hidden') && this.$elements[emptyInputs[0]]?.querySelector('input')?.value === '') {
                        this.$elements[emptyInputs[0]]?.classList?.remove('valid');
                        this.$elements[emptyInputs[0]]?.classList?.remove('invalid');
                        this.$elements[emptyInputs[0]]?.querySelector('.error-tooltip')?.remove();
                    }
                }

                if (invalidInputsOnStep[0] > emptyInputsOnStep[0]) { // On each step
                    if (elements[invalidInputsOnStep[0]]?.querySelector('input')?.id === 'daypicker') {
                        isNaN(str) && validations.push(this.validateField(elements[i], data, options));
                        this.isDateValid = true;
                    }

                    !this.isDateValid && elements[i]?.querySelector('input')?.value !== '' && validations.push(this.validateField(elements[i], data, options));

                    // Second reg step only
                    const secondStep = $('.circle-2');
                    const secondStepElem = secondStep && secondStep[0];
                    if (secondStepElem?.classList?.contains('active') && !secondStepElem?.classList?.contains('prevStep')) {
                        const dateParam = $('.date-picker-field')[0]?.value?.split('.').join('');
                        const isIncludeNumber = /\d/.test(dateParam);
                        if (isIncludeNumber && dateParam?.toString().length < 8) { // Date DD-MM-YYYY 8 digits
                            validations.push(this.validateField(this.$elements[3], data, options));
                            break;
                        }
                    }

                    const invalidInputVal = this.$elements[invalidInputsOnStep[0]]?.querySelector('input')?.value === '';
                    invalidInputVal && this.$elements[invalidInputsOnStep[0]]?.classList?.remove('valid');
                    invalidInputVal && this.$elements[invalidInputsOnStep[0]]?.classList?.remove('invalid');
                    invalidInputVal && this.$elements[invalidInputsOnStep[0]]?.querySelector('.error-tooltip')?.remove();
                    this.isDateValid = false;
                }

                if (elements[i]?.querySelector('input')?.id === 'daypicker') {
                    isNaN(str) && validations.push(this.validateField(elements[i], data, options));
                }
            }

            if (this.isStopValidate) {
                break; // Validate only first invalid and then break validation loop
            }

            if (!elements.hasClass('fn-lookup')) { // If not address lookup form
                if (!elements[i]?.classList?.contains('valid') && !elements[i]?.classList?.contains('invalid') && !elements[i]?.classList?.contains('radio')) {
                    if (emptyInputs.length > 0 && invalidInputs.length === 0 && $('.passwordRule')[0]?.classList?.contains('hidden')) {
                        validations.push(this.validateField(elements[emptyInputs[0]], data, options));
                        break;
                    }
                }
            }

            elements[i]?.classList?.contains('invalid') && validations.push(this.validateField(elements[i], data, options));

            if (elements[i]?.classList?.contains('radio') && isRadioInvalid && invalidElementsExceptRadioBox.length > 0) {
                elements[i].querySelector('.error-tooltip').remove();
            }

            const validateEmptyInputs = () => {
                if (emptyInputs.length > 1) {
                    emptyInputs.slice(1).reverse().forEach((el) => {
                        elements[el]?.classList?.remove('valid');
                        elements[el]?.classList?.remove('invalid');
                        elements[el]?.querySelector('.error-tooltip')?.remove();
                    });
                    validations.push(this.validateField(elements[emptyInputs[0]], data, options));
                }
            };

            if (!elements[i]?.classList?.contains('invalid') && !elements[i]?.classList?.contains('valid')) {
                if (elements[i].getElementsByTagName('input')[0].value === '' && $('.error-tooltip')[0]) {
                    i++;
                }

                if (!$('.passwordRule')[0]?.classList?.contains('hidden')) { // If password rule table
                    validations.push(this.validateField($('.password')[0], data, options)); // Validate only password field
                    break;
                }

                if (invalidInputs[0] > 0 && elements[i]?.getElementsByTagName('input')[0]?.value !== '') {
                    validations.push(this.validateField(elements[invalidInputs[0]], data, options));
                } else {
                    if (elements[i]?.className?.includes('lookup')) {
                        emptyInputs.length > 0 && invalidInputs.length === 0 && validations.push(this.validateField(elements[i], data, options));
                        validateEmptyInputs();
                    } else {
                        elements[i]?.getElementsByTagName('input')[0]?.value !== '' && validations.push(this.validateField(elements[i], data, options));
                    }
                }
            }

            const elementsWithoutHidden = elements.filter((el) => !el?.classList?.contains('address-lookup-hidden'));
            const emptyInputsWithoutHidden = elementsWithoutHidden.filter((el) => el?.querySelector('input')?.value === '');

            if (elementsWithoutHidden[i]?.className?.includes('lookup')) {
                emptyInputs.length > 0 && invalidInputs.length === 0 && validations.push(this.validateField(emptyInputsWithoutHidden[0], data, options));
                validateEmptyInputs();
            } else if (elementsWithoutHidden[0]?.className?.includes('lookup')) {
                emptyInputs.length > 0 && invalidInputs.length === 0 && validations.push(this.validateField(elements[emptyInputsOnStep[0]], data, options));
            }

            if (elements[i]?.classList?.contains('password')) {
                const passwordRules = $('.password-container-rules')[0];
                const passwordErrorsList = passwordRules && passwordRules.getElementsByClassName('first-level-item');
                for (let j = 0; j < passwordErrorsList.length; j++) {
                    if (!passwordErrorsList[j]?.classList?.contains('valid') && !$('.passwordRule')[0]?.classList?.contains('hidden')) {
                        validations.push(this.validateField(elements[i], data, options));
                        break;
                    }
                }
            }
        }

        return validations;
    };

    Form.prototype.processValidationsAllFields = function(elements, data, options) {
        let validations = [];
        let emptyInputs = [];
        let invalidInputs = [];
        const isTransactionHistoryForm = this.el?.classList?.contains('form_name_transaction-history');

        // Validate transaction history fields
        if (isTransactionHistoryForm) {
            validations = elements.map(function(field) {
                return this.validateField(field, data, options);
            }, this);

            return validations;
        }

        // Checking input fields and write index to array
        for (let t = 0; t < elements.length; ++t) {
            if (elements[t]?.getElementsByTagName('input')[0]?.value === '') {
                emptyInputs.push(t);
            }

            if (elements[t]?.classList?.contains('invalid')) {
                invalidInputs.push(t);
            }
        }

        for (let i = 0; i < elements.length; ++i) {
            if (this.isStopValidate) {
                break; // Validate only first invalid and then break validation loop
            }

            if (elements[invalidInputs[0]]?.querySelector('input')?.value !== '' && invalidInputs.length > 0 && emptyInputs.length > invalidInputs.length) {
                validations.push(this.validateField(elements[invalidInputs[0]], data, options));
                break;
            } else {
                if (emptyInputs.length > 1) {
                    // Validate first empty and clear rest but not first
                    validations.push(this.validateField(elements[emptyInputs[0]], data, options));
                    emptyInputs.slice(1).reverse().forEach((el) => {
                        elements[el]?.classList?.remove('valid');
                        elements[el]?.classList?.remove('invalid');
                        elements[el]?.querySelector('.error-tooltip')?.remove();
                    });
                }

                // Clear invalid between empty fields
                if (elements[emptyInputs[0]]?.querySelector('input')?.value === '' && invalidInputs.length > 1 && elements[emptyInputs[0]]?.classList?.contains('invalid')) {
                    elements[emptyInputs[0]]?.classList?.remove('valid');
                    elements[emptyInputs[0]]?.classList?.remove('invalid');
                    elements[emptyInputs[0]]?.querySelector('.error-tooltip')?.remove();
                }

                invalidInputs.length === 0 && validations.push(this.validateField(elements[emptyInputs[0]], data, options));
                elements[i]?.classList?.contains('invalid') && validations.push(this.validateField(elements[i], data, options));
            }

            elements[i]?.classList?.contains('invalid') && validations.push(this.validateField(elements[i], data, options));

            if (!elements[i]?.classList?.contains('invalid') && !elements[i]?.classList?.contains('valid')) {
                emptyInputs.length > 0 && invalidInputs.length === 0 && validations.push(this.validateField(elements[invalidInputs[0]], data, options));
            }
        }

        return validations;
    };

    Form.prototype.handleTogglePasswordVisibility = function(e) {
        e.stopPropagation();
        e.preventDefault();

        var $passwordVisisbilityControl = $(e.target);
        var $inputPassword = $passwordVisisbilityControl.parent().find('.fn-input-type-password');

        $passwordVisisbilityControl.toggleClass('password-visibility--enabled');
        $inputPassword.attr('type', $inputPassword.attr('type') === 'password' ? 'text' : 'password');
        e.target.parentNode.querySelector('input').focus();
    };

    module.exports = Form;
});
